import { getFullUrl } from 'hubspot-url-utils';
export const prefetchPage = (pagePrefetchRoute, options = {}) => {
  const pageRoute = pagePrefetchRoute.replace(/^\/+/, '');
  const iframeId = `prefetcher-${pageRoute}`; // Prevent duplicate appending iframe

  if (document.getElementById(iframeId)) {
    return;
  }

  const {
    url = getFullUrl('app')
  } = options;
  const iframe = document.createElement('iframe');
  iframe.id = iframeId;
  iframe.src = `${url}/${pageRoute}`;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
};